import React from "react";
import { motion } from "framer-motion";
import GoogleReviews from "./GoogleReviews";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="container hero-container">
        <motion.p
          className="section-subheading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Testimonials
        </motion.p>

        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Words from Our Happy Patients
        </motion.h2>

     <motion.div
  className="testimonials-reviews-wrapper"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.15 }}
  variants={fadeUp}
>
  <GoogleReviews layout="slider" limit={3} />
</motion.div>

        <motion.div
          className="hero-btns"
          initial={{
            opacity: 0,
            y: 20,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 1,
            delay: 0.4,
          }}
        >
          <motion.a
            href="/testimonials"
            className="secondary-btn"
            whileHover={{
              scale: 1.04,
            }}
            transition={{
              duration: 0.4,
            }}
          >
            Read all Testimonials
          </motion.a>

          <motion.a
            href="/book-appointment"
            className="nav-btn"
            whileHover={{
              scale: 1.04,
            }}
            transition={{
              duration: 0.4,
            }}
          >
            Book Appointment
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;